<template>
  <div class="footer-module">
    <div class="row">
      <div class="item">
        <div class="name font-foot-title en b">Address</div>
        <div class="desc">
          <span class="font-foot-subtitle b">中国杭州市</span>
          <span class="font-foot-subtitle b">西湖区东信和创园</span>
          <span class="font-foot-subtitle b">31幢元白展厅</span>
        </div>
      </div>
      <div class="item">
        <div class="name font-foot-title en b">Opening</div>
        <div class="desc">
          <span class="font-foot-subtitle en">11:00-18:00</span>
          <span class="font-foot-subtitle b">周一定休</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <div class="name font-foot-title en b">Social</div>
        <div class="desc">
          <span class="font-foot-subtitle en hove-link" @click="openWeb('https://www.instagram.com/gallery_yuanbai/')">Instagram</span>
          <span class="font-foot-subtitle en hove-link" @click="openWeb('https://www.xiaohongshu.com/user/profile/5f8fc21200000000010041ad')">RED</span>
          <span class="font-foot-subtitle en hove-link" @click="openWeb('https://weibo.com/u/5496017278')">Weibo</span>
        </div>
      </div>
      <div class="item">
        <div class="name font-foot-title en b">Shopping</div>
        <div class="desc">
          <span class="font-foot-subtitle en hove-link" @click="showWechat">WeChat</span>
          <span class="font-foot-subtitle en hove-link" @click="openWeb('https://shop443130758.taobao.com/?spm=a230r.7195193.1997079397.1.6f161fa25zp2Z6')">Taobao</span>
        </div>
        <div class="qrcode" v-if="wechat" @click="hiddenWechat"><img src="@/assets/img/qr.png"></div>
      </div>
    </div>
    <div class="copyright en font-copyrigth">© 2024 Hangzhou Yuanbai Cultural Creativity Co., Ltd. All rights reserved.</div>
    <p class="cover"></p>
  </div>

</template>

<script >
export default {
    name:"footerComponent",
    components: {
    },
    data() {
        return {
          wechat:false
        }
    },
    methods:{
      showWechat(){
        this.wechat=true;
      },
      hiddenWechat(){
        this.wechat=false;
      },

      openWeb(url){
        if(url){
          window.open(url, '_blank');
        }
      },
    }
};
</script>
<style lang="less" scoped>
.footer-module{
  border-top: 0.5px solid #4d4d4d;
  width: 100%;
  height: 182px;
  padding: 50px;
  position: relative;
  display: flex;
  .qrcode{
    position: absolute;
    z-index: 1;
    background-color: #F3F3F3;
    width: 74px;
    height: 74px;
    left: 0px;
    top: 0px;
  }
  .row{
    display: flex;
  }
  .item{
    margin-right: 60px;
    position: relative;
    .desc{
      margin-top: 10px;
      span{
        line-height: 16px;
        display: block;
      }
    }
    .links{
      span{
        cursor: pointer;
      }
    }
  }
  .copyright{
    position: absolute;
    bottom: 50px;
    right: 50px;
  }
  .cover {
    width: 100%;
    height: 51px;
    background: url('./../../assets/img/footer-bg.png') no-repeat center center;
    background-size: cover;
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
}

@media screen and (max-width: 1023px) {
  .footer-module {
    height: 306px;

    padding: 40px 20px 20px 20px;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    row-gap: 24px;
    .qrcode{
      width: 74px;
      height: 74px;
    }
    .row{
      justify-content: column;
      width: 100%;
    }
    .item{
      align-self: flex-start;
      width: 50%;
    }
    .copyright{
      left: 20px;
      right: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue